<template>
  <div class="pa-4">
    <v-data-table
      class="price-levels"
      :items-per-page="10"
      :search="searchSymbol"
      item-key="ticker.user"
      ref="vDataTableTicker"
      :headers="headers"
      :items="data"
      show-expand
      no-data-text="No symbols available. Connect to your platform first"
      single-expand
      :expanded.sync="expanded"
    >
      <template v-slot:top>
        <v-toolbar class="pt-2 px-4" flat color="#333b47">
          <v-text-field
            name="findSymbol"
            v-model="searchSymbol"
            append-icon="search"
            label="Find Symbol"
            single-line
            color="#4dbac0"
            hide-details
          ></v-text-field>
        </v-toolbar>
      </template>

      <template v-slot:item.data-table-expand="props">
        <v-btn
          :class="{
                  'v-data-table__expand-icon': true,
                  'v-data-table__expand-icon--active': props.isExpanded && transitionedTicker[getItemIdTicker(props.item)]
                  }"
          @click="toggleExpandTicker(props)"
          text
          icon
          color="white"
        >
          <v-icon>mdi-chevron-down</v-icon>
        </v-btn>
      </template>
      <template v-slot:item.action="{ item }">
        <div>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" @click="copyLevels(item)" text icon color="white">
                <v-icon>sync_alt</v-icon>
              </v-btn>
            </template>
            <span>copy levels</span>
          </v-tooltip>

          <!--
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                :disabled="item.ticker.levels > 0 ? false : true"
                v-on="on"
                @click="removeLevel(item)"
                text
                icon
                color="white"
              >
                <v-icon>delete_forever</v-icon>
              </v-btn>
            </template>
            <span>delete all levels</span>
          </v-tooltip>

          -->

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" @click="addLevel(item)" text icon color="white">
                <v-icon>add_circle_outline</v-icon>
              </v-btn>
            </template>
            <span>add new level</span>
          </v-tooltip>
        </div>
      </template>
      <template v-slot:expanded-item="{ headers, item  }">
        <td
          :colspan="headers.length"
          style="background-color: #333b47; padding-bottom: 0px;height: auto;"
        >
          <v-expand-transition>
            <!-- Container we'll transition -->
            <div v-show="transitionedTicker[getItemIdTicker(item)]">
              <!-- container for content. replace with whatever you want -->
              <div style="min-height: 100px;">
                <v-data-table
                  class="price-levels-deep"
                  ref="vDataTable"
                  no-data-text="No price levels for symbol"
                  :items-per-page="-1"
                  :search="searchLevel"
                  :headers="subHeaders"
                  :items="item.levels"
                  item-key="_id"
                  :loading="loadinglevels"
                  :expanded.sync="expandedDetail"
                  show-expand
                  single-expand
                  :sort-by="['price']"
                  :sort-desc="[true]"
                >
                  <template v-slot:no-data>
                    No price levels for symbol.
                    <span
                      @click="addLevel(item)"
                      style="color: #25a7f9;cursor: pointer"
                    >
                      Add first one
                      <v-icon color="#25a7f9">add_circle_outline</v-icon>
                    </span>
                  </template>
                  <template v-slot:item.data-table-expand="props">
                    <v-icon
                      v-if="props.item.description.length > 0 || props.item._images.length > 0"
                      :class="{
                  'v-data-table__expand-icon': true,
                  'v-data-table__expand-icon--active': props.isExpanded && transitioned[getItemId(props.item)]
                  }"
                      @click="toggleExpand(props)"
                    >mdi-chevron-down</v-icon>
                  </template>
                  <template v-slot:top>
                    <v-row v-if="item.levels.length > 0">
                      <v-toolbar class="pt-2 px-4 deep-tool" flat color="#404855">
                        <v-text-field
                          name="findPrice"
                          v-model="searchLevel"
                          append-icon="search"
                          label="Find Level"
                          single-line
                          color="#4dbac0"
                          hide-details
                        ></v-text-field>
                      </v-toolbar>
                    </v-row>
                  </template>
                  <template v-slot:expanded-item="{ headers, item  }">
                    <td
                      :colspan="headers.length"
                      style="background-color: #333b47;height: auto;"
                      class="py-3"
                    >
                      <v-expand-transition>
                        <!-- Container we'll transition -->
                        <div v-show="transitioned[getItemId(item)]">
                          <!-- container for content. replace with whatever you want -->
                          <div style="min-height: 100px;">
                            <div class="width-full float-left">{{item.description}}</div>
                            <div
                              v-if="item._images.length>0"
                              class="width-full float-left pt-3"
                              :class="{'ma-0 pa-0': true, 'expanded-closing': !transitioned[getItemId(item)]}"
                            >
                              <vue-picture-swipe :items="item._images"></vue-picture-swipe>
                            </div>
                          </div>
                        </div>
                      </v-expand-transition>
                    </td>
                  </template>
                  <template v-slot:item.type="{ item }">
                    <v-icon v-if="item.type == 'Long' " color="#79C04D">trending_up</v-icon>
                    <v-icon v-if="item.type == 'Short' " color="#E62163">trending_down</v-icon>
                    <v-icon v-if="item.type == 'Neutral' " color="#808F9C">trending_flat</v-icon>
                  </template>
                  <template v-slot:item.high="{ item }">{{item.high - item.low}}</template>
                  <template v-slot:item.action="{ item }">
                    <div>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn v-on="on" @click="removeOneLevel(item)" text icon color="white">
                            <v-icon>remove_circle_outline</v-icon>
                          </v-btn>
                        </template>
                        <span>delete level</span>
                      </v-tooltip>
                    </div>
                  </template>
                </v-data-table>
              </div>
            </div>
          </v-expand-transition>
        </td>
      </template>
    </v-data-table>

    <v-dialog v-model="newLevelDialog" :loading="addLoading" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ addTicker }}</span>
        </v-card-title>

        <v-card-text class="pa-2">
          <div
            style="height: 162px;width:97%;position:absolute;top:127px;right:8px;"
            :class="newItem.type"
          ></div>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  color="#4dbac0"
                  ref="highPrice"
                  v-model="newItem.high"
                  @focus="focusOn = 'high'"
                  type="number"
                  :disabled="disHigh"
                  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                  maxlength="13"
                  :error-messages="errHigh"
                  label="Level High"
                  name="high"
                ></v-text-field>
              </v-col>

              <v-col cols="4" sm="4" md="4">
                <v-text-field
                  color="#4dbac0"
                  v-model="newItem.price"
                  @focus="focusOn = 'price'"
                  ref="price"
                  :error-messages="errPrice"
                  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                  maxlength="13"
                  :disabled="disPrice"
                  type="number"
                  label="Mid Price"
                  name="price"
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="4" md="4">
                <v-combobox
                  v-model="newItem.name"
                  :rules="rules"
                  counter="10"
                  ref="shortName"
                  :items="names"
                  name="keywords"
                  :search-input.sync="namesNew"
                  itemText="name"
                  label="Short Name"
                  color="#4dbac0"
                  hide-no-data
                  :menu-props="{ bottom: true, offsetY: true }"
                ></v-combobox>
              </v-col>

              <v-col cols="12" sm="4" md="4">
                <v-select
                  v-model="newItem.type"
                  :items="type"
                  label="Type"
                  color="#4dbac0"
                  :menu-props="{ bottom: true, offsetY: true }"
                >
                  <template v-slot:selection="data">
                    <span
                      :class="data.item == 'Long' ? 'profit' : data.item == 'Short' ? 'loss' : ''"
                    >{{ data.item }}</span>
                  </template>
                  <template v-slot:item="data">
                    <span
                      :class="data.item == 'Long' ? 'profit' : data.item == 'Short' ? 'loss' : ''"
                    >{{ data.item }}</span>
                  </template>
                </v-select>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  color="#4dbac0"
                  v-model="newItem.low"
                  @focus="focusOn = 'low'"
                  :disabled="disLow"
                  :error-messages="errLow"
                  type="number"
                  label="Level Low"
                  name="low"
                  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                  maxlength="13"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-col style="margin-top: -30px" cols="12" sm="12" md="12">
          <TextInput
            placeholder="Level comment..."
            @imgData="imgData"
            @textData="textData"
            :reset="textInputReset"
            icon
            upload
          />
        </v-col>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
          <v-btn color="blue darken-1" :disabled="myValidation()" text @click="saveNew">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deleteLevelDialog" :loading="removeLoading" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Remove all levels for symbol {{deleteSymbol}}?</span>
        </v-card-title>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close">No</v-btn>
          <v-btn color="blue darken-1" text @click="removeConfirm">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deleteOneLevelDialog" :loading="removeOneLoading" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Remove level {{deletePrice}}?</span>
        </v-card-title>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close">No</v-btn>
          <v-btn color="blue darken-1" text @click="removeOneConfirm">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="copyLevelsDialog" max-width="500px">
      <v-card :loading="copyLevelsLoading">
        <v-card-title>
          <span class="headline">Sync Levels</span>
        </v-card-title>
        <v-card-text v-if="copySymbol">
          From
          <b>{{copySymbol.user}}</b> to:
          <v-select
            v-model="copyTo"
            :items="dataRaw"
            item-text="user"
            label="Contract"
            color="#4dbac0"
            :error-messages="errCopy"
            return-object
            :menu-props="{ bottom: true, offsetY: true }"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="copyLevelsProceed">Confirm</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
var moment = require("moment");
import _ from "lodash";
import TextInput from "@/components/textInputBig.vue";
import axios from "axios";
import VuePictureSwipe from "vue-picture-swipe";

export default {
  name: "PriceLevels",
  components: { TextInput, VuePictureSwipe },

  data() {
    return {
      names: ["HVN daily", "LVN daily", "IBL", "IBH"],
      namesNew: null,

      transitioned: [],
      closeTimeouts: {},
      singleExpand: false,

      transitionedTicker: [],
      closeTimeoutsTicker: {},
      singleExpandTicker: false,

      textInputReset: new Date(),
      formHasErrors: false,
      rules: [v => v.length <= 10 || "Max 10 characters"],
      rulesRequired: [value => !!value || "Required."],
      errors: "nic",
      disPrice: false,
      disHigh: false,
      disLow: false,
      errHigh: [],
      errLow: [],
      errPrice: [],
      errCopy: [],

      setH: 0,
      setP: 0,
      setL: 0,
      focusOn: null,

      formData: null,
      debug: null,
      //ticker: null,
      type: ["Long", "Neutral", "Short"],
      addLoading: false,
      removeLoading: false,
      removeOneLoading: false,
      newLevelDialog: false,
      copyLevelsDialog: false,
      copyLevelsLoading: false,
      copySymbol: null,
      copyTo: null,
      copyAlert: false,
      deleteLevelDialog: false,
      deleteOneLevelDialog: false,
      deleteSymbol: null,
      deleteId: null,
      deletePrice: null,
      addTicker: null,
      newItem: {
        document: "Levels",
        name: "",
        price: null,
        high: null,
        low: null,
        width: null,
        description: "",
        ticker: null,
        images: [],
        type: "Neutral"
      },
      loadinglevels: false,
      expanded: [],
      expandedDetail: [],
      searchSymbol: null,
      searchLevel: null,
      // DATA FROM BEKEND
      data: [],
      dataRaw: [],
      headers: [
        {
          text: "Ticker",
          align: "left",
          sortable: true,
          value: "ticker.user"
        },
        {
          text: "Levels",
          align: "left",
          sortable: true,
          value: "ticker.levels"
        },
        { text: "", value: "action", sortable: false, align: "right" }
      ],
      subHeaders: [
        {
          text: "Price",
          align: "center",
          sortable: true,
          value: "price"
        },
        {
          text: "Width",
          align: "center",
          sortable: true,
          value: "high"
        },
        {
          text: "Type",
          align: "center",
          sortable: true,
          value: "type"
        },
        {
          text: "Name",
          align: "left",
          sortable: false,
          value: "name"
        },
        { text: "", value: "action", sortable: false, align: "right" }
      ],
      newKeysLocal: [],
      keyNew: null,
      keywords: ["IBL", "IN RANGE"],
      keywordsSelected: [],
      recommand: [
        "No Estimate",
        "Strong Buy",
        "Buy",
        "Neutral",
        "Sell",
        "Strong Sell"
      ],
      recommandSelected: "No Estimate",
      today: moment().format("dddd MM/DD/YYYY")
    };
  },

  watch: {
    copyLevelsDialog: function(newVal) {
      if (!newVal) {
        this.copyTo = null;
        this.errCopy = [];
      }
    },
    copyTo: function(newVal) {
      if (newVal.global != this.copySymbol.global) {
        this.errCopy.push(
          "You want to copy levels to another market. Are you sure?"
        );
      } else {
        this.errCopy = [];
      }
    },
    "newItem.high": function(newVal) {
      this.newItem.high = newVal;
      //this.errReset();

      if (newVal) {
        //newVal = newVal.replace("e", "");
        if (this.focusOn == "high") {
          this.setH = Date.now();
          if (this.setP > 0 && this.setL == 0) this.disLow = true;
          if (this.setP == 0 && this.setL > 0) this.disPrice = true;
        }

        if (this.disLow) {
          if (parseFloat(newVal) < parseFloat(this.newItem.price)) {
            this.errHigh = ["lower than mid"];
            this.newItem.low = null;
          } else {
            this.errHigh = [];
            this.errLow = [];
            this.errPrice = [];
            this.newItem.low =
              parseFloat(this.newItem.price) -
              (parseFloat(this.newItem.high) - parseFloat(this.newItem.price));
            if (this.newItem.low < 0) {
              this.newItem.low = null;
              this.errHigh = ["low is negative"];
            }
          }
        }

        if (this.disPrice) {
          if (parseFloat(newVal) < parseFloat(this.newItem.low)) {
            this.errHigh = ["lower than low"];
            this.newItem.price = null;
          } else {
            this.errHigh = [];
            this.errLow = [];
            this.errPrice = [];
            this.newItem.price =
              parseFloat(this.newItem.high) -
              (parseFloat(this.newItem.high) - parseFloat(this.newItem.low)) /
                2;
          }
        }
      } else {
        this.setH = 0;
        this.errHigh = [];
        if (this.setP == 0 && this.setL > 0) {
          this.disPrice = false;
          this.newItem.price = null;
        }
        if (this.setP > 0 && this.setL == 0) this.disLow = false;
      }
    },
    "newItem.low": function(newVal) {
      //this.errReset();

      if (newVal) {
        //newVal = newVal.replace("e", "");
        if (this.focusOn == "low") {
          this.setL = Date.now();
          if (this.setP > 0 && this.setH == 0) this.disHigh = true;
          if (this.setP == 0 && this.setH > 0) this.disPrice = true;
        }

        if (this.disHigh) {
          if (parseFloat(newVal) > parseFloat(this.newItem.price)) {
            this.errLow = ["higher than mid"];
            this.newItem.high = null;
          } else {
            this.errHigh = [];
            this.errLow = [];
            this.errPrice = [];
            this.newItem.high =
              parseFloat(this.newItem.price) +
              (parseFloat(this.newItem.price) - parseFloat(this.newItem.low));
          }
        }
        if (this.disPrice) {
          if (parseFloat(newVal) > parseFloat(this.newItem.high)) {
            this.errLow = ["higher than high"];
            this.newItem.price = null;
          } else {
            this.errHigh = [];
            this.errLow = [];
            this.errPrice = [];
            this.newItem.price =
              parseFloat(this.newItem.high) -
              (parseFloat(this.newItem.high) - parseFloat(this.newItem.low)) /
                2;
          }
        }
      } else {
        this.setL = 0;
        this.errLow = [];
        if (this.setP == 0 && this.setH > 0) {
          this.disPrice = false;
          this.newItem.price = null;
        }
        if (this.setP > 0 && this.setH == 0) this.disHigh = false;
      }
      if (this.newItem.low < 0) {
        this.newItem.low = null;
        this.errLow = ["low is negative"];
      }
    },
    "newItem.price": function(newVal) {
      //this.errReset("price");

      if (newVal) {
        //newVal = newVal.replace("e", "");
        if (this.focusOn == "price") {
          this.setP = Date.now();
          if (this.setH > 0 && this.setL == 0) this.disLow = true;
          if (this.setH == 0 && this.setL > 0) this.disHigh = true;
        }

        if (this.disHigh) {
          if (parseFloat(newVal) < parseFloat(this.newItem.low)) {
            this.errPrice = ["lower than low"];
            this.newItem.high = null;
          } else {
            this.errHigh = [];
            this.errLow = [];
            this.errPrice = [];
            this.newItem.high =
              parseFloat(this.newItem.price) +
              (parseFloat(this.newItem.price) - parseFloat(this.newItem.low));
          }
        }
        if (this.disLow) {
          if (parseFloat(newVal) > parseFloat(this.newItem.high)) {
            this.errPrice = ["higher than high"];
            this.newItem.low = null;
          } else {
            this.errHigh = [];
            this.errLow = [];
            this.errPrice = [];
            this.newItem.low =
              parseFloat(this.newItem.price) -
              (parseFloat(this.newItem.high) - parseFloat(this.newItem.price));
            if (this.newItem.low < 0) {
              this.newItem.low = null;
              this.errPrice = ["low is negative"];
            }
          }
        }
      } else {
        this.setP = 0;
        this.errPrice = [];
        if (this.setL > 0 && this.setH == 0) this.disHigh = false;
        if (this.setL == 0 && this.setH > 0) {
          this.disLow = false;
          this.newItem.low = null;
        }
      }
      //this.errReset("price");
    },

    expanded(newVal) {
      if (newVal.length > 0) {
        this.loadinglevels = true;
        this.getLevels(newVal[0].ticker.user);
      }
    },
    newLevelDialog(newVal) {
      if (!newVal) {
        this.textInputReset = new Date();
        this.newItemReset();
      }
    },
    singleExpand(v) {
      if (!v) return;
      // Single expand enabled. Hide all but the first expanded item
      this.expandedDetail.forEach((item, i) => {
        if (i > 0) this.closeExpand(item);
      });
    },
    singleExpandTicker(v) {
      if (!v) return;
      // Single expand enabled. Hide all but the first expanded item
      this.expanded.forEach((item, i) => {
        if (i > 0) this.closeExpandTicker(item);
      });
    }
  },

  computed: {},

  mounted() {
    this.getNames();
    this.getSymbolList();
  },

  methods: {
    copyLevelsProceed() {
      this.copyLevelsLoading = true;

      axios
        .post("https://tradeinpool.com:3001/api/update/levels/", {
          method: "copy",
          from: this.copySymbol,
          to: this.copyTo
        })
        .then(() => {
          this.getNames();
          this.getSymbolList();
          this.copyLevelsLoading = false;
          this.copyLevelsDialog = false;
        });
    },

    copyLevels(item) {
      this.copyLevelsDialog = true;
      this.copySymbol = item.ticker;
    },
    myValidation() {
      if (this.errHigh.length > 0) return true;
      if (this.errLow.length > 0) return true;
      if (this.errPrice.length > 0) return true;

      if (!this.newItem.price && !this.newItem.high && !this.newItem.low)
        return true;
      if (!this.newItem.price && this.newItem.high && !this.newItem.low)
        return true;
      if (!this.newItem.price && !this.newItem.high && this.newItem.low)
        return true;

      return false;
    },
    close() {
      this.newLevelDialog = false;
      this.deleteLevelDialog = false;
      this.deleteOneLevelDialog = false;
    },
    addLevel(item) {
      this.newItem.ticker = item.ticker;
      this.addTicker = item.ticker.user;
      this.newLevelDialog = true;
    },
    removeLevel(item) {
      this.deleteLevelDialog = true;
      this.deleteSymbol = item.ticker.user;
    },
    removeOneLevel(item) {
      this.deleteOneLevelDialog = true;
      this.deleteSymbol = item.ticker.user;
      this.deletePrice = item.price;
      this.deleteId = item._id;
    },
    saveNew() {
      // requred fields check
      this.formHasErrors = false;
      this.formHasErrors = this.myValidation();

      if (this.newItem["name"].length > 10) this.formHasErrors = true;
      this.$refs["shortName"].validate(true);

      if (this.newItem.price && !this.newItem.high && !this.newItem.low) {
        this.newItem.high = this.newItem.price;
        this.newItem.low = this.newItem.price;
      }

      //alert(this.formHasErrors);
      if (!this.formHasErrors) {
        //var newName = this.newItem.name.replace("_", "-");
        //var newNameNext = newName.replace(":", "-");
        this.addLoading = true;
        this.loadinglevels = true;
        // prepare api data
        let formData = new FormData();
        formData.append("parentType", this.newItem.document);
        formData.append("parentId", null);
        formData.append("description", this.newItem.description);
        formData.append("name", this.namesNew);
        formData.append("price", this.newItem.price);
        formData.append("high", this.newItem.high);
        formData.append("low", this.newItem.low);
        formData.append("tickerUser", this.newItem.ticker.user);
        //formData.append("tickerGlobal", this.newItem.ticker.global);
        //formData.append("tickerPool", this.newItem.ticker.pool);
        //formData.append("tickerMonth", this.newItem.ticker.expMonth);
        //formData.append("tickerYear", this.newItem.ticker.expYear);
        formData.append("type", this.newItem.type);
        this.newItem.images.forEach(fileItem => {
          formData.append("img", fileItem);
        });

        axios
          .post("https://tradeinpool.com:3001/api/add/levels/", formData)
          .then(response => {
            //alert("mam data")
            this.getNames();
            this.pushLevel(response.data);
            this.newItemReset();
            this.addLoading = false;
            this.newLevelDialog = false;
            this.flash("Price level saved.", "success", {
              timeout: 2000
            });
            //if(this.expanded)
            //this.setLevels(response.data);
            //this.setInitData(response.data);
          });
      }
    },
    setInitData(data) {
      this.data = [];
      data.forEach(level => {
        if (!level.levels) level.levels = 0;
        this.data.push({ ticker: level, levels: [] });
        this.dataRaw.push(level);
      });
      this.dataRaw = _.orderBy(this.dataRaw, ["user"], ["asc"]); // Use Lodash to sort array by 'name'
    },

    setNames(data) {
      this.names = [];
      data.forEach(name => {
        this.names.push(name.name);
      });
    },

    getNames() {
      axios
        .post("https://tradeinpool.com:3001/api/request/levelnames/")
        .then(response => {
          this.setNames(response.data);
        });
    },
    getSymbolList() {
      axios
        .post("https://tradeinpool.com:3001/api/request/symbollist/")
        .then(response => {
          //alert("mam data")
          this.debug = response.data;
          this.loading = false;
          this.setInitData(response.data);
        });
    },
    getLevels(symbol) {
      axios
        .post("https://tradeinpool.com:3001/api/request/levels/", {
          ticker: symbol
        })
        .then(response => {
          this.debug = response.data;
          this.setLevels(response.data);
        });
    },
    removeConfirm() {
      this.removeLoading = true;
      axios
        .post("https://tradeinpool.com:3001/api/remove/levels/", {
          method: "all",
          ticker: this.deleteSymbol
        })
        .then(response => {
          //alert("mam data")
          this.removeAllLevels(response.data);
          this.removeLoading = false;
          this.deleteLevelDialog = false;
        });
    },
    removeOneConfirm() {
      this.removeOneLoading = true;
      axios
        .post("https://tradeinpool.com:3001/api/remove/levels/", {
          id: this.deleteId
        })
        .then(response => {
          //alert("mam data")
          this.removeOne(response.data);
          this.removeOneLoading = false;
          this.deleteOneLevelDialog = false;
          this.flash("Price level deleted.", "success", {
            timeout: 2000
          });
        });
    },
    setLevels(resp) {
      if (resp.length > 0) {
        this.data.forEach((ticker, index) => {
          if (ticker.ticker.user == resp[0].ticker.user) {
            this.data[index].levels = resp;
          }
        });
        this.loadinglevels = false; // hide loading
      } else {
        this.loadinglevels = false; // hide loading
      }
    },
    pushLevel(resp) {
      if (resp) {
        this.data.forEach((ticker, index) => {
          if (ticker.ticker.user == resp.ticker.user) {
            if (this.data[index].ticker.levels)
              this.data[index].ticker.levels += 1;
            else this.data[index].ticker.levels = 1;
            this.data[index].levels.unshift(resp);
          }
        });
        this.loadinglevels = false; // hide loading
      } else {
        this.loadinglevels = false; // hide loading
      }
    },
    removeAllLevels(resp) {
      if (resp) {
        this.data.forEach((ticker, index) => {
          if (ticker.ticker.user == resp) {
            this.data[index].levels = [];
            this.data[index].ticker.levels = 0;
          }
        });
      }
    },
    removeOne(resp) {
      if (resp) {
        this.data.forEach((ticker, index) => {
          ticker.levels.forEach((level, idx) => {
            if (level._id == resp) {
              this.data[index].levels.splice(idx, 1);
              this.data[index].ticker.levels -= 1;
            }
          });
        });
      }
    },
    imgData(data) {
      this.newItem.images = data;
    },
    textData(data) {
      this.newItem.description = data;
    },
    newItemReset() {
      this.disHigh = false;
      this.disLow = false;
      this.disPrice = false;
      this.newItem = {
        document: "Levels",
        name: "",
        price: null,
        high: null,
        low: null,
        width: null,
        description: "",
        ticker: null,
        images: [],
        type: "Neutral"
      };

      this.formHasErrors = false;
      //this.$refs["shortName"].reset();
      this.$refs["price"].reset();
    },

    getItemId(item) {
      return item._id; // Must be uid of record (would be nice if v-data-table exposed a "getItemKey" method)
    },
    getItemIdTicker(item) {
      return item.user; // Must be uid of record (would be nice if v-data-table exposed a "getItemKey" method)
    },
    toggleExpand(props) {
      const item = props.item;
      const id = this.getItemId(item);
      if (props.isExpanded && this.transitioned[id]) {
        // If we're expanded and not in the process of closing, close
        this.closeExpand(item);
      } else {
        // If we're closed or in the process of closing, expand
        // Stop us from closing if a close transition was started
        clearTimeout(this.closeTimeouts[id]);
        // Tell v-data-table to add the expansion content for the item
        props.expand(true);
        // Show expansion content with transition animation after it's had time to get added to the DOM
        this.$nextTick(() => this.$set(this.transitioned, id, true));
        // Hide all other expanded items if single-expand
        if (this.singleExpand)
          this.$nextTick(() =>
            this.expandedDetail.forEach(i => i !== item && this.closeExpand(i))
          );
      }
    },
    toggleExpandTicker(props) {
      const item = props.item;
      const id = this.getItemIdTicker(item);
      if (props.isExpanded && this.transitionedTicker[id]) {
        // If we're expanded and not in the process of closing, close
        this.closeExpandTicker(item);
      } else {
        // If we're closed or in the process of closing, expand
        // Stop us from closing if a close transition was started
        clearTimeout(this.closeTimeoutsTicker[id]);
        // Tell v-data-table to add the expansion content for the item
        props.expand(true);
        // Show expansion content with transition animation after it's had time to get added to the DOM
        this.$nextTick(() => this.$set(this.transitionedTicker, id, true));
        // Hide all other expanded items if single-expand
        if (this.singleExpandTicker)
          this.$nextTick(() =>
            this.expanded.forEach(i => i !== item && this.closeExpandTicker(i))
          );
      }
    },
    closeExpand(item) {
      const id = this.getItemId(item);
      // Mark that this item is in the process of closing
      this.$set(this.transitioned, id, false);
      // Remove expansion content from DOM after transition animation has had enough time to finish
      this.closeTimeouts[id] = setTimeout(
        () => this.$refs.vDataTable.expand(item, false),
        300
      );
    },
    closeExpandTicker(item) {
      const id = this.getItemIdTicker(item);
      // Mark that this item is in the process of closing
      this.$set(this.transitionedTicker, id, false);
      // Remove expansion content from DOM after transition animation has had enough time to finish
      this.closeTimeoutsTicker[id] = setTimeout(
        () => this.$refs.vDataTableTicker.expand(item, false),
        300
      );
    }
  }
};
</script>



<style scoped>
.Long {
  background-color: rgba(0, 255, 0, 0.1);
}
.Short {
  background-color: rgba(255, 0, 0, 0.1);
}

.Neutral {
  background-color: rgba(255, 255, 255, 0.1);
}
</style>
